/**
 * 炼器配方数据
 */

export interface ForgeIngredient {
  itemId: string;
  itemName: string;
  count: number;
}

export interface ForgeRecipe {
  id: string;
  name: string;
  desc: string;
  /** 产出物品ID */
  resultItemId: string;
  /** 最低炼器等级 */
  minSkill: number;
  /** 材料 */
  ingredients: ForgeIngredient[];
}

export const FORGE_RECIPES: ForgeRecipe[] = [
  {
    id: 'forge_iron_sword',
    name: '铁剑铸造',
    desc: '以凡铁为基，以灵草淬火，打造最基础的修士兵器。',
    resultItemId: 'iron_sword',
    minSkill: 0,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 3 },
    ],
  },
  {
    id: 'forge_cloth_armor',
    name: '布衣缝制',
    desc: '将灵草纤维织入布料，制成最基础的防御衣物。',
    resultItemId: 'cloth_armor',
    minSkill: 0,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 2 },
    ],
  },
  {
    id: 'forge_spirit_sword',
    name: '灵剑锻造',
    desc: '以妖丹为引，灵草为辅，锻造蕴含灵力的宝剑。',
    resultItemId: 'spirit_sword',
    minSkill: 3,
    ingredients: [
      { itemId: 'monster_core', itemName: '妖丹', count: 3 },
      { itemId: 'spirit_herb', itemName: '灵草', count: 5 },
    ],
  },
  {
    id: 'forge_spirit_armor',
    name: '灵甲锻造',
    desc: '将妖丹融入甲胄，灵力流转自成防护。',
    resultItemId: 'spirit_armor',
    minSkill: 3,
    ingredients: [
      { itemId: 'monster_core', itemName: '妖丹', count: 2 },
      { itemId: 'spirit_herb', itemName: '灵草', count: 3 },
    ],
  },
  {
    id: 'forge_jade_pendant',
    name: '玉佩雕琢',
    desc: '以灵草温养玉石，制成温润经脉的饰品。',
    resultItemId: 'jade_pendant',
    minSkill: 2,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 5 },
    ],
  },
  {
    id: 'forge_dark_sword',
    name: '玄铁重剑',
    desc: '以大量妖丹淬炼玄铁，铸就削铁如泥的神兵。',
    resultItemId: 'dark_sword',
    minSkill: 8,
    ingredients: [
      { itemId: 'monster_core', itemName: '妖丹', count: 8 },
      { itemId: 'spirit_herb', itemName: '灵草', count: 5 },
    ],
  },
  {
    id: 'forge_flame_ring',
    name: '烈焰环',
    desc: '将妖丹中的火属灵力凝聚成环，佩戴者攻击力大增。',
    resultItemId: 'flame_ring',
    minSkill: 6,
    ingredients: [
      { itemId: 'monster_core', itemName: '妖丹', count: 5 },
      { itemId: 'spirit_herb', itemName: '灵草', count: 3 },
    ],
  },
];

/** 基础成功率 */
export const BASE_FORGE_RATE = 0.25;
/** 每级熟练度加成 */
export const FORGE_SKILL_BONUS = 0.02;
